<template lang="pug">
  header.header(:class="{scrolled: scrolled}")
    MTHeader
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import MTHeader from '@/components/MTHeader'

export default {
  name: 'Header',
  components: {
    MTHeader
  },
  data() {
    return {
      scrollY: null,
      scrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', _.throttle(this.throttledScroll, 250));
  },
  computed: mapState([
    'config'
  ]),
  methods: {
    throttledScroll() {
      const headerHeight = this.$el.getBoundingClientRect().height
      if(headerHeight < window.scrollY){
        this.scrolled = true
      } else {
        this.scrolled = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header{
    position: fixed;
    left: 0;
    right: 0;
    z-index: 6;
    background: linear-gradient(45deg, #282d2e,#454d47,#282d2e);
    will-change: transform;
    transition: all .3s;
    &.scrolled{
      @media all and (min-width: 900px){
        transform: translateY(-119px);
      }
    }
  }
</style>

